import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Grid, Row, Col, Dropdown } from 'react-bootstrap';

import Greeting from '../../../partials/Greeting';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm } from "../../../../store/actions/FormAction";

import "./hamburger.css";

const NavLink = props => (
  <li>
    <Link {...props} />
  </li>
);

class CustomToggle extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <a id="dashmenu" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

class CustomMenu extends Component {
  render() {
    let linkStyle1 = "disabled active";
    let linkStyle2 = "";
    let linkStyle3 = "hidden";
    let linkStyle4 = "hidden";
    let linkStyle5 = "hidden";

    if(this.props.accountstatus === "Originated" || this.props.accountstatus === "Default" || this.props.accountstatus === "Delinquent" || this.props.accountstatus === "Default SIF/PIF" || this.props.accountstatus === "Paid Off" || this.props.accountstatus === "Pending Paid Off"){
      linkStyle3 = "";
      linkStyle4 = "";
      linkStyle5 = "";
    } else if(this.props.accountstatus !== "Pending" && this.props.accountstatus !== "Fast Tracked" && this.props.accountstatus !== "Withdrawn"){
      linkStyle3 = "";
    } else if(this.props.accountstatus === "Recommended for Approval"){
      linkStyle3 = "";
      linkStyle5 = "";
    }

    if(this.props.currentpage!=="viewaccount"){
      linkStyle1 = "";
      switch(this.props.currentpage){
        case "viewprofile":
          linkStyle2 = "disabled active";
          break;
        case "viewschedule":
          linkStyle3 = "disabled active";
          break;
        case "viewhistory":
          linkStyle4 = "disabled active";
          break;
        case "viewagreement":
          linkStyle5 = "disabled active";
          break;
        default:
          break;
      }
    }
    if (this.props.currentpage==="viewprofile"){

      linkStyle2 = "disabled active";
    }
    if (this.props.currentpage==="viewschedule"){

      linkStyle3 = "disabled active";

      linkStyle4 = "";
      linkStyle5 = "";
    }

    if (this.props.accounttype === "Line of Credit"){
      return (
          <ul className="dropdown-menu">
            <NavLink className={linkStyle1} to="/dashboard/viewaccount">Account</NavLink>
            <NavLink className={linkStyle2} to="/dashboard/viewprofile">Profile</NavLink>
            <NavLink className={linkStyle3} to="/dashboard/viewhistory">Transaction History</NavLink>
            <NavLink className={linkStyle4} to="/dashboard/viewstatements">Statements</NavLink>
            <NavLink className={linkStyle5} to="/dashboard/viewagreement">Agreement</NavLink>
            <NavLink to="/logout">Log out</NavLink>
          </ul>
      );
    } else {
      return (
          <ul className="dropdown-menu">
            <NavLink className={linkStyle1} to="/dashboard/viewaccount">Account</NavLink>
            <NavLink className={linkStyle2} to="/dashboard/viewprofile">Profile</NavLink>
            <NavLink className={linkStyle4} to="/dashboard/viewhistory">Loan History</NavLink>
            <NavLink className={linkStyle3} to="/dashboard/viewschedule">Payment Schedule</NavLink>
            <NavLink className={linkStyle5} to="/dashboard/viewagreement">Loan Agreement</NavLink>
            <NavLink to="/logout">Log out</NavLink>
          </ul>
      );
    }

  }
}

class DashMenu extends Component {
  constructor(){
    super();

    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    //For testing purposes
    if (this.props.fn.length < 1) this.props.updateForm("fn", "John");
  }

  handleClick(e){
    document.getElementById("hamburger").classList.toggle("is-active");
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Dropdown id="dashmenu" block>
              <CustomToggle bsRole="toggle">
              <button id="hamburger" className="hamburger hamburger--collapse" type="button" onClick={this.handleClick}>
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              </CustomToggle><Greeting />
              <CustomMenu bsRole="menu" currentpage={this.props.page} accounttype={this.props.loantype} accountstatus={this.props.status}></CustomMenu>
            </Dropdown>
          </Col>
          <img style={{marginTop:'-44px'}} className="style-svg smalllogo pull-right" src="/images/logo/logo-small.svg" height="30px" alt="MoneyKey Small Logo"/>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
    fn: state.FormReducer.fn,
    page: state.FormReducer.page,
    status: state.FormReducer.status,
    loantype: state.FormReducer.loantype
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(DashMenu);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/DashMenu.js